import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';
import SolutionList from '../components/solutionList';
class Content1 extends React.PureComponent {
  render() {
    const { dataSource, isMobile,article,detail,...props} = this.props;
    const {
      wrapper,
      titleWrapper,
      page,
      OverPack: overPackData,
      childWrapper,
    } = dataSource;

    const  {title,date,description,content,author,source,viewNum} = detail;
    console.log('detail解决方案详情',detail);
    var detailHtml = ()=>{
      if (Object.keys(detail).length) {
        return (
          <div className="detail-content-wrapper" style={{paddingLeft:'50px',paddingRight:'50px'}}>
             <div className="detail-sub-title">
              {/* <div>发布时间：{date} </div>
              <div>作者：{author||'本站编辑'} </div>
              <div>来源：{source||'本站原创'} </div>
              <div>浏览次数：{viewNum||'5586'} </div> */}
             </div>

             <div className="detail-article" style={{lineHeight: '2em'}}>
              {/* ruleInfo为需展示的数据 */}
             
                <div dangerouslySetInnerHTML={{ __html: content }} />
             </div>

          </div>
        )
      }else{
        return (
          <div className="detail-content-wrapper">
             <div className="detail-sub-title">
              <div>发布时间：2022-07-10 </div>
              <div>作者：本站编辑 </div>
              <div>来源：本站原创 </div>
              <div>浏览次数：2356 </div>
             </div>

             <div className="detail-article">
              {/* ruleInfo为需展示的数据 */}
                <div dangerouslySetInnerHTML={{ __html: article }} />
             </div>

          </div>
        )
      }
    }
    // console.log('article-1',article);
    return (
      <div {...props} {...wrapper}>
        <div {...page}>
          <div {...titleWrapper}>
            {titleWrapper.children.map(getChildrenToRender)}
          </div>
          { detailHtml() }
         
        </div>
      </div>
    );
  }
}

export default Content1;
